/**
 * AnimationPlayer registration: parser and property formatter.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseAnimationPlayer } from './parser';
import { formatAnimationPlayerProperties } from './propertyFormatter';
const animationPlayerRegistration = {
    typeName: 'AnimationPlayer',
    parser: parseAnimationPlayer,
    propertyFormatter: formatAnimationPlayerProperties,
};
nodeRegistry.register(animationPlayerRegistration);
export * from './parser';
export * from './propertyFormatter';
export * from './types';
//# sourceMappingURL=index.js.map